import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { actions, type AppDispatch } from 'state';
import analytics from '../analytics';
import api from '../api';

/**
 * Marks or unmarks a traditional or alternative lender as preferred, then
 * updates `has_preferred_lenders`/`has_preferred_alt_lenders` on the current
 * user from the toggle response, instead of refetching the full user.
 */
const usePreferredLenderToggle = () => {
  const dispatch = useDispatch<AppDispatch>();

  return useCallback(
    async (lenderId: number, isPreferred: boolean, isAltLender = false): Promise<void> => {
      const basePath = isAltLender ? 'alt-lenders' : 'lenders';

      const response = isPreferred
        ? await api.put(`${basePath}/${lenderId}/preferred`)
        : await api.delete(`${basePath}/${lenderId}/preferred`);

      const type = isAltLender ? 'Alternative' : 'Traditional';
      if (isPreferred) {
        analytics.lenders.preferred.added(lenderId, type);
      } else {
        analytics.lenders.preferred.removed(lenderId, type);
      }

      dispatch(actions.users.preferredLendersUpdated(response.data));
    },
    [dispatch]
  );
};

export default usePreferredLenderToggle;
